import CustomButton from "../../../../../components/CustomButton";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import SvgIcon from "../../../../../helpers/SvgIcon";
import { postCreateTraceability } from "../../../../../redux/api/expedition.api";
import { fetchCargoNode } from "../../../../../redux/api/raports.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { CargoNodeDataInterface } from "../../../../../redux/interfaces/raports.interface";

function CargoNodeActionButtons({
  crudData,
}: {
  itemId: string;
  crudData: CargoNodeDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();

  const { nr_volum, id_doctrans_detl, id_doctrans } = crudData;

  const handleUploadPackageInCar = async () => {
    const resultAction = await dispatch(
      postCreateTraceability({
        id_doctrans_detl: id_doctrans_detl,
        nr_volum: nr_volum,
        id_doctrans: id_doctrans,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postCreateTraceability) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchCargoNode({
          page: 1,
          perPage: 999,
          idNod: crudData.id_nod,
        }),
      );
    }
  };

  const wrongDestination =
    !crudData.sn_bin && crudData.id_nod !== crudData.id_nod_destinatie_colet;

  return (
    <>
      {crudData.doc_trans && !wrongDestination && (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          tooltipTitle="Incarca coletul in masina"
          withConfirmationModal={{
            modalTitle: "Incarca coletul in masina",
            modalSubtitle: `Doriti sa incarcati in masina coletul cu nr. awb ${crudData.doc_trans}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleUploadPackageInCar,
          }}>
          <SvgIcon type="UPLOAD_CARGO" fill="white" />
        </CustomButton>
      )}
    </>
  );
}

export default CargoNodeActionButtons;
